import { render, staticRenderFns } from "./newYearScroll.vue?vue&type=template&id=754914a4&scoped=true&"
import script from "./newYearScroll.vue?vue&type=script&lang=js&"
export * from "./newYearScroll.vue?vue&type=script&lang=js&"
import style0 from "./newYearScroll.vue?vue&type=style&index=0&id=754914a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754914a4",
  null
  
)

export default component.exports